var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSysCheckIn = function SvgSysCheckIn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3.54 2.924h8.472c.452 0 .818.39.818.872V8.63c.258.12.5.27.722.449V3.796c0-.907-.69-1.642-1.54-1.642H3.54C2.69 2.154 2 2.89 2 3.796v9.027c0 .907.69 1.642 1.54 1.642h4.958a3.91 3.91 0 0 1-.421-.77H3.54c-.452 0-.818-.39-.818-.872V3.796c0-.482.366-.872.818-.872Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.39 9.075c-1.595 0-2.888 1.378-2.888 3.078s1.293 3.078 2.888 3.078 2.888-1.378 2.888-3.078-1.293-3.078-2.888-3.078Zm-3.61 3.078c0-2.125 1.616-3.847 3.61-3.847 1.994 0 3.61 1.722 3.61 3.847S13.384 16 11.39 16c-1.994 0-3.61-1.722-3.61-3.847ZM13.183 5.959H2.353v-.684h10.83v.684ZM4.88 1c.2 0 .361.172.361.385v2.308c0 .212-.161.385-.36.385-.2 0-.362-.173-.362-.385V1.385c0-.213.162-.385.361-.385ZM10.656 1c.2 0 .361.172.361.385v2.308c0 .212-.161.385-.36.385-.2 0-.362-.173-.362-.385V1.385c0-.213.162-.385.361-.385Z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10.698 13.774a.403.403 0 0 1-.004-.543l1.007-1.093-1.003-1.05a.403.403 0 0 1-.004-.544.345.345 0 0 1 .51-.005l1.26 1.32a.398.398 0 0 1 .109.27c0 .103-.037.2-.104.274l-1.26 1.367a.345.345 0 0 1-.51.005Z",
    clipRule: "evenodd"
  })));
};
export default SvgSysCheckIn;